import React from 'react';
import styles from './Loading.module.css';

interface LoadingProps {
    fullPage?: boolean;
    message?: string;
    size?: 'sm' | 'md' | 'lg';
}

const Loading: React.FC<LoadingProps> = ({
    fullPage = false,
    message = 'Loading...',
    size = 'md'
}) => {
    const containerClasses = [
        styles.loadingContainer,
        fullPage ? styles.fullPage : '',
        styles[size]
    ].join(' ');

    return (
        <div className={containerClasses}>
            <div className={styles.spinner}>
                <div className={styles.doubleBounce1}></div>
                <div className={styles.doubleBounce2}></div>
            </div>
            {message && <p className={styles.message}>{message}</p>}
        </div>
    );
};

export default Loading;
